/* eslint-disable no-inline-styles/no-inline-styles */
import React, { useState, useEffect } from 'react';
import * as ReactDOM from 'react-dom';
import { observer } from 'mobx-react';
import * as CONSTANTS from 'Utils/constants';
import StepIcon from 'Assets/png/personalised_onboarding/step1.png';
import { ReactComponent as CloseIcon } from 'Assets/svg/close-material.svg';
import { personalisedOnboardingState } from 'Stores/personalisedOnboardingState';
import { advSearchState } from 'Stores/advSearch';
import { companySearchState } from 'Stores/companySearch';
import { Utils } from 'Utils/utils';

const {
  PERSONALIED_ONBOARDING_FLOWS,
  MX_PERSONALISED_ONBOARDING_EVENTS,
} = CONSTANTS;
const {
  EMAIL_CAMPAIGN_LIST,
  TARGETED_ACCOUNTS,
  AD_AUDIENCE_LIST,
} = PERSONALIED_ONBOARDING_FLOWS;
const { LB_GOAL_CURRENT_STEP_VALUE } = MX_PERSONALISED_ONBOARDING_EVENTS;
const { DEFINE } = LB_GOAL_CURRENT_STEP_VALUE;

const TITLE = {
  EMAIL_CAMPAIGN_LIST: 'Goal : Email Campaign List - Step 1',
  TARGETED_ACCOUNTS: 'Goal : Build Target Accounts List - Step 1',
  AD_AUDIENCE_LIST: 'Goal : Build Custom Ad Audience - Step 1',
};

const StepOneTopWrapper = observer(() => {
  const { isPersonalisedOnboardingFlow } = personalisedOnboardingState;
  const handleCloseClick = () => {
    const eventName = Utils.personalisedOnboardingEventMap(
      isPersonalisedOnboardingFlow,
    );
    if (eventName) Utils.mixpanelTrack(eventName, { closed: DEFINE });
    personalisedOnboardingState.clearOnboardingFlow();
  };
  return (
    <>
      <div className="sharp-point" />
      <div className="close-icon-wrapper">
        <CloseIcon className="close-icon" onClick={e => handleCloseClick()} />
      </div>
      <div className="onboarding-img-wrapper">
        <img src={StepIcon} alt="StepIcon" />
      </div>
      <div className="onboarding-title-wrapper">
        <div className="title">{TITLE[isPersonalisedOnboardingFlow]}</div>
        <div className="progress-bar">
          <div className="progress-bar-fill" />
        </div>
      </div>
    </>
  );
});

const EmailCampaignList = observer(props => {
  const {
    onboardingCurrentStep,
    isPersonalisedOnboardingFlow,
  } = personalisedOnboardingState;
  const [positionData, setPositionData] = useState({
    topPosition: 0,
    leftPosition: 0,
    display: 'none',
  });

  useEffect(() => {
    const element = document.getElementsByClassName('top-filter-group');

    let topPosition = 0;
    let leftPosition = 0;

    if (element && element.length > 0) {
      const boundries = element[0].getBoundingClientRect();
      const { top, left, width } = boundries;
      topPosition = top;
      leftPosition = left + width + 14;
      setPositionData({
        topPosition,
        leftPosition,
        display: 'block',
      });
    }
  }, []);

  const handleNextCick = () => {
    if (advSearchState.searchResultCount > 0) {
      const eventName = Utils.personalisedOnboardingEventMap(
        isPersonalisedOnboardingFlow,
      );
      if (eventName) Utils.mixpanelTrack(eventName, { currentStep: DEFINE });
      personalisedOnboardingState.setOnboardingCurrentStep(
        onboardingCurrentStep + 1,
      );
    }
  };

  const handleSkipClick = () => {
    const eventName = Utils.personalisedOnboardingEventMap(
      isPersonalisedOnboardingFlow,
    );
    if (eventName) Utils.mixpanelTrack(eventName, { skipped: DEFINE });
    personalisedOnboardingState.clearOnboardingFlow();
  };

  return (
    <div
      className="onboarding-flow-step-popup "
      style={{
        top: `${positionData.topPosition}px`,
        left: `${positionData.leftPosition}px`,
        display: `${positionData.display}`,
      }}
    >
      <StepOneTopWrapper />
      <div className="bottom-wrapper">
        <div className="info-title">Define Campaign List</div>
        <div className="description">
          <span>Use the filters to segment your email campaign list.</span>
          <span>
            You can further segment using the Include/Exclude options for sub
            industries.
          </span>
        </div>
        <div className="action-btn-wrapper">
          <div className="skip-link" onClick={e => handleSkipClick()}>
            Skip guided tour
          </div>
          <div
            className={`action-btn ${
              advSearchState.searchResultCount > 0 ? 'btn-enabled' : ''
            }`}
            onClick={e => handleNextCick(e)}
          >
            Next
          </div>
        </div>
      </div>
    </div>
  );
});

const TargetAccountList = observer(props => {
  const {
    onboardingCurrentStep,
    isPersonalisedOnboardingFlow,
  } = personalisedOnboardingState;
  const [positionData, setPositionData] = useState({
    topPosition: 0,
    leftPosition: 0,
    display: 'none',
  });

  useEffect(() => {
    const element = document.getElementsByClassName('top-filter-group');

    let topPosition = 0;
    let leftPosition = 0;

    if (element && element.length > 0) {
      const boundries = element[0].getBoundingClientRect();
      const { top, left, width } = boundries;
      topPosition = top;
      leftPosition = left + width + 14;
      setPositionData({
        topPosition,
        leftPosition,
        display: 'block',
      });
    }
  }, []);

  const handleNextCick = () => {
    if (companySearchState.searchResultCount > 0) {
      const eventName = Utils.personalisedOnboardingEventMap(
        isPersonalisedOnboardingFlow,
      );
      if (eventName) Utils.mixpanelTrack(eventName, { currentStep: DEFINE });
      personalisedOnboardingState.setOnboardingCurrentStep(
        onboardingCurrentStep + 1,
      );
    }
  };
  const handleSkipClick = () => {
    const eventName = Utils.personalisedOnboardingEventMap(
      isPersonalisedOnboardingFlow,
    );
    if (eventName) Utils.mixpanelTrack(eventName, { skipped: DEFINE });
    personalisedOnboardingState.clearOnboardingFlow();
  };

  return (
    <div
      className="onboarding-flow-step-popup "
      style={{
        top: `${positionData.topPosition}px`,
        left: `${positionData.leftPosition}px`,
        display: `${positionData.display}`,
      }}
    >
      <StepOneTopWrapper />
      <div className="bottom-wrapper">
        <div className="info-title">Define Target Audience</div>
        <div className="description">
          <span>Use the filters to segment your target audience.</span>
          <span>
            You can further segment using the Include/Exclude options for sub
            industries or uploading a list of company URLs as a CSV.
          </span>
        </div>
        <div className="action-btn-wrapper">
          <div className="skip-link" onClick={e => handleSkipClick()}>
            Skip guided tour
          </div>
          <div
            className={`action-btn ${
              companySearchState.searchResultCount > 0 ? 'btn-enabled' : ''
            }`}
            onClick={e => handleNextCick(e)}
          >
            Next
          </div>
        </div>
      </div>
    </div>
  );
});

const AdAudienceList = observer(props => {
  const {
    onboardingCurrentStep,
    isPersonalisedOnboardingFlow,
  } = personalisedOnboardingState;
  const [positionData, setPositionData] = useState({
    topPosition: 0,
    leftPosition: 0,
    display: 'none',
  });

  useEffect(() => {
    const element = document.getElementsByClassName('top-filter-group');

    let topPosition = 0;
    let leftPosition = 0;

    if (element && element.length > 0) {
      const boundries = element[0].getBoundingClientRect();
      const { top, left, width } = boundries;
      topPosition = top;
      leftPosition = left + width + 14;
      setPositionData({
        topPosition,
        leftPosition,
        display: 'block',
      });
    }
  }, []);

  const handleNextCick = () => {
    if (companySearchState.searchResultCount > 0) {
      const eventName = Utils.personalisedOnboardingEventMap(
        isPersonalisedOnboardingFlow,
      );
      if (eventName) Utils.mixpanelTrack(eventName, { currentStep: DEFINE });
      personalisedOnboardingState.setOnboardingCurrentStep(
        onboardingCurrentStep + 1,
      );
    }
  };
  const handleSkipClick = () => {
    const eventName = Utils.personalisedOnboardingEventMap(
      isPersonalisedOnboardingFlow,
    );
    if (eventName) Utils.mixpanelTrack(eventName, { skipped: DEFINE });
    personalisedOnboardingState.clearOnboardingFlow();
  };

  return (
    <div
      className="onboarding-flow-step-popup "
      style={{
        top: `${positionData.topPosition}px`,
        left: `${positionData.leftPosition}px`,
        display: `${positionData.display}`,
      }}
    >
      <StepOneTopWrapper />
      <div className="bottom-wrapper">
        <div className="info-title">Define your Target</div>
        <div className="description">
          <span>
            Use the filters to segment and choose targets you want to advertise
            to.
          </span>
          <span>
            Include / Exclude sub industries for further segmentation. You can
            also choose to upload a set of companies you want to suppress in
            this list.
          </span>
        </div>
        <div className="action-btn-wrapper">
          <div className="skip-link" onClick={e => handleSkipClick()}>
            Skip guided tour
          </div>
          <div
            className={`action-btn ${
              companySearchState.searchResultCount > 0 ? 'btn-enabled' : ''
            }`}
            onClick={e => handleNextCick(e)}
          >
            Next
          </div>
        </div>
      </div>
    </div>
  );
});

const OnboardingStepOnePopup = observer(props => {
  const { isPersonalisedOnboardingFlow } = personalisedOnboardingState;

  return ReactDOM.createPortal(
    isPersonalisedOnboardingFlow === EMAIL_CAMPAIGN_LIST ? (
      <EmailCampaignList />
    ) : isPersonalisedOnboardingFlow === TARGETED_ACCOUNTS ? (
      <TargetAccountList />
    ) : isPersonalisedOnboardingFlow === AD_AUDIENCE_LIST ? (
      <AdAudienceList />
    ) : (
      ''
    ),
    document.getElementById('portal-dom-root'),
  );
});

export { OnboardingStepOnePopup };
export default OnboardingStepOnePopup;
